import { render, staticRenderFns } from "./MenuAccesos.vue?vue&type=template&id=33d045e6&scoped=true&"
import script from "./MenuAccesos.vue?vue&type=script&lang=js&"
export * from "./MenuAccesos.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/globals.css?vue&type=style&index=0&id=33d045e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d045e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VAutocomplete,VCard,VCol,VListItemContent,VListItemSubtitle,VListItemTitle,VRow})
